import styled from 'styled-components'

export const DashboardContainer = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
  flex-direction: column;
  background-color: #f6f6f6;
  overflow-y: scroll;

  .progress-section {
    display: flex;
    width: 100%;
    align-items: center;

    /* .content-children {
      width: 100%;
      gap: 30px;
    } */
  }

  .route-children {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .content-children {
      width: 100%;
    }
  }

  .individual-class {
    /* border: 1px solid red; */
    width: 45%;
    border: 1px solid rgba(0, 0, 0, 0.07);
    border-radius: 10px;

    .content-children {
      width: 100%;
      margin-top: 10px;
    }

    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }
`
